import { createEffect } from "effector";
import { activateVacuumCleaner, getVacuumCleanersByStation, sendReceipt } from "../../services/vacuumService";
import { AppError } from "../../services/classes";
import { Receipt, VacuumActivation, VacuumOption } from "../../types/vacuum.types";

export const fetchVacuumCleanersEffect = createEffect<string, VacuumOption[], AppError>(async (station: string) => {
  return await getVacuumCleanersByStation(station);
});

export const activateVacuumCleanerEffect = createEffect<VacuumActivation, void, Error>(async (payload: VacuumActivation) => {
  const fixedPayload = {
    ...payload,
    time_on: payload.time_on * 60
  }
  
  await activateVacuumCleaner(fixedPayload);
});

export const sendReceiptEffect = createEffect<Receipt, void, AppError>(async (receipt: Receipt) => {
  const response = await sendReceipt(receipt);

  return response;
});